<template>
  <div class="container-fluid">

    <div class="row">
      <div class="col-12 text-left">
        <router-link :to="{ name: 'TagTrash', }" class="">
          <button class="btn mx-1 rounded-pill btn-danger">سطل زباله</button>
        </router-link>
        <router-link :to="{ name: 'TagCreate', }" class="">
          <button class="btn mx-1 rounded-pill btn-primary">ساخت</button>
        </router-link>

        <language-select-box class="d-inline-block col-auto" @changeLanguage="changeLanguage" module-name="tag"/>


      </div>
    </div>

    <div class="my-3" v-if="refresh">
      <tag-table table-mode="data"/>
    </div>

  </div>
</template>


<script>
import Pagination from "@/plugin/components/dashboard/Pagination.vue";
import TagTable from "@/plugin/components/dashboard/Tag/TagTable.vue";
import LanguageSelectBox from "@/plugin/components/dashboard/Language/LanguageSelectBox.vue";

export default {
  name: "Tag",
  components: {TagTable, Pagination, LanguageSelectBox},
  data() {
    return {
      refresh: true
    }
  },
  methods: {
    changeLanguage() {
      this.refresh = false
      setTimeout(() => {
        this.refresh = true
      }, 500)
    }
  }
}
</script>

<style scoped>

</style>